<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    classNameBackground: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    parsedParts() {
      return this.parseRichText(this.text);
    },
  },
  methods: {
    parseRichText(input) {
      const parts = [];
      let remaining = input;
      const regex = /(__.*?__)|(--\[.*?\]--)/g;
      let match;
      let lastIndex = 0;
      while ((match = regex.exec(remaining)) !== null) {
        if (match.index > lastIndex) {
          parts.push({
            tag: 'span',
            text: remaining.slice(lastIndex, match.index),
            class: this.className + ' ' + '',
          });
        }
        const token = match[0];
        if (token.startsWith('__') && token.endsWith('__')) {
          parts.push({
            tag: 'span',
            text: token.slice(2, -2),
            class:
              this.className +
              ' ' +
              this.classNameBackground +
              ' ' +
              'text-white px-2.5 py-0.5 rounded-md bg-secondary text-nowrap leading-[130%]',
          });
        } else if (token.startsWith('--[') && token.endsWith(']--')) {
          parts.push({
            tag: 'span',
            text: token.slice(3, -3),
            class: this.className + ' ' + 'text-formule',
          });
        }
        lastIndex = regex.lastIndex;
      }
      if (lastIndex < remaining.length) {
        parts.push({
          tag: 'span',
          text: remaining.slice(lastIndex),
          class: this.className + ' ' + '',
        });
      }
      return parts;
    },
  },
};
</script>

<template>
  <component v-for="(part, index) in parsedParts" :key="index" :is="part.tag" :class="part.class">
    {{ part.text }}
  </component>
</template>
